export const translate = {
	es: {
		'Indiferente': 'Indiferente',
		'Junior - 0 a 3 años': 'Junior - 0 a 3 años',
		'Mediano - 3 a 7 años': 'Mediano - 3 a 7 años',
		'Senior - 10 años o más': 'Senior - 10 años o más',
	},

	pt: {
		'Indiferente': 'Indiferente',
		'Junior - 0 a 3 años': 'Júnior - 0 a 3 anos',
		'Mediano - 3 a 7 años': 'Mediano - 3 a 7 anos',
		'Senior - 10 años o más': 'Sênior - 10 anos ou mais',
	},
}
